// Shared preview symbols for internal chat and WhatsApp message notifications.
export const MEDIA_MESSAGE_LABELS = {
  image: ["📷", "Photo"],
  video: ["🎥", "Video"],
  audio: ["🎵", "Audio"],
  voice: ["🎤", "Voice message"],
  document: ["📄", "Document"],
  sticker: ["🏷️", "Sticker"],
};
